"use client";
import React from "react";
import {
  Breadcrumb,
  BreadcrumbProvider,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbLink,
  BreadcrumbSeparator,
  BreadcrumbPage,
} from "@dxp-feed/ui/Breadcrumb";

type BreadcrumbData = {
  text: string;
  href: string | null;
  ariaLabel?: string;
};
type BreadcrumbWrapperProps = {
  breadcrumbList: BreadcrumbData[];
  type?: string;
};

const BreadcrumbWrapper: React.FC<BreadcrumbWrapperProps> = ({
  breadcrumbList,
  type,
}) => {
  const getBreadcrumbItem = (
    item: BreadcrumbData,
    type?: string,
    index?: number,
  ) => {
    if (index === 0) {
      return (
        <BreadcrumbLink ariaLabel={`click to ${item.text}`} href={item?.href ?? "#"}>{item.text}</BreadcrumbLink>
      );
    }

    if (!item.href) {
      return <BreadcrumbPage>{item.text}</BreadcrumbPage>;
    }

    if (type === "products") {
      return <span>{item?.text}</span>;
    }

    return <BreadcrumbLink href={item.href}>{item.text}</BreadcrumbLink>;
  };
  return (
    <BreadcrumbProvider separator="/">
      <Breadcrumb className="py-4">
        <BreadcrumbList className="flex-wrap">
          {breadcrumbList.map((item, index) => (
            <React.Fragment key={item.text}>
              <BreadcrumbItem className="[&>span]:line-clamp-1 [&>span]:!font-bold [&>a+span]:!font-normal [&>span]:!capitalize">
                {getBreadcrumbItem(item, type, index)}
                {index < breadcrumbList.length - 1 && <BreadcrumbSeparator />}
              </BreadcrumbItem>
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </BreadcrumbProvider>
  );
};

export default BreadcrumbWrapper;
